import request from '@/router/axios'
import { commonConst } from '@/const/code.js'
import { encrypt, addClass, removeClass } from "@/util/util";
import { base64Encode } from "@/util/endecode.js";
const prefix = process.env.VUE_APP_ACCOUNT_CLOUD_BASE_URL;

export const loginByUsername = (username, password, validCode, phoneNum, verifyCode, loginType, targetSys) => {   //登录接口
  const grant_type = 'password';
  const scope = 'server';
  //const tenantId = commonConst.TENANT_ID;
  return request({
    url: '/login/loginCloud',
    headers: {
       // Authorization: 'Basic d2FnZTp3YWdl',
      //Authorization: 'Basic Y2lpYy1jbG91ZC1wbGF0Zm9ybTpjaWljLWNsb3VkLXBsYXRmb3Jt',
    },
    method: 'post',
    params: { loginName: username, password, validCode, phoneNum, verifyCode, loginType, targetSys},
    data: { loginName: username, password, validCode, phoneNum, verifyCode, loginType, targetSys},
  });
};
export function getUser() {
  return request(
    {
      url: '/getUser',
      method:'get'
    }
  )
}

export function updatePwd(data) {
  return request(
    {
      url: '/login/updatePwd',
      method:'post',
      data
    }
  )
}


export function checkUser(data) {
  return request(
    {
      url: '/PmsUser/checkUser',
      method:'post',
      data
    }
  )
}

export function loginToken(obj) {
  return request(
    {
      url: '/userlogin/'+obj,
      method:'get'
    }
  )
}

export const requestRefreshToken = (refresh_token) => {
  const grant_type = 'refresh_token';
  const scope = 'server';
  const type = '1';
  const tenantId = commonConst.TENANT_ID;
  return request({
    url: '/auth/oauth/token',
    headers: {
      Authorization: 'Basic d2FnZTp3YWdl',
    },
    method: 'post',
    params: { grant_type, scope, refresh_token,type,tenantId},
  });
};



export const logout = (accesstoken, refreshToken) => request({   //tod  退出接口
  url: '/login/out',
  method: 'post',
  params: { accesstoken, refreshToken },
  data: { accesstoken, refreshToken },
});
export const cacheUser = (userId, orgId, createOrgId) => request({ //todo  缓存用户信息
  url: '/user/user/cache',
  method: 'post',
  data: { userId, orgId, createOrgId },
});

// 嵌套的iframe页面加载
export function iframePageLoad(url,accessToken) {
  var lang = localStorage.getItem("lang");
  lang = lang || 'zh' ;
  return request({
    // url: prefix + url,
     url: '/accountCloud' + url,
    method: 'post',
    params: {
      lang: base64Encode(lang),
      accessToken: accessToken,
      aacode: 'invoice'
    }
  });
}

export function userResetPassword(data) {
  return request({
    url: "/login/userResetPassword",
    method: 'POST',
    data: data
  });
}

export function sendSmsVerifyCode(data) {
  return request({
    url: "/login/sendSmsVerifyCode",
    method: 'POST',
    data: data
  });
}